/**
 * Created by elmar on 01/27/2017.
 */

(function($) {
    'use strict';

    (new function() {
        var __body_id = '#page__companies_index';
        var __table   = '#dt-table';

        var SEARCH_ROW = {};
        var COLUMNS    = [
            {
                data        : 'currency_id',
                title       : '',
                orderable   : false,
                className   : 'text-center',
                customsearch: false,
                width       : '20px',
                render      : function(data, type, row) {
                    return '<span class="label label-blue label-small">' + row.currency.code + '</span>';
                }
            },
            {
                data        : 'name',
                title       : 'Name',
                orderable   : true,
                className   : 'text-center',
                customsearch: true
            },
            {
                data        : 'price_list_date',
                title       : 'Price List Date',
                orderable   : false,
                className   : 'text-center',
                customsearch: true
            },
            {
                data        : 'discount',
                title       : 'Discount',
                orderable   : false,
                className   : 'text-center',
                customsearch: true
            },
            {
                data        : 'domain',
                title       : 'Domain',
                orderable   : false,
                className   : 'text-center',
                customsearch: true,
                render      : function(data, type, row) {
                    return '<span class="label label-success fc-block">' + data + '</span>';
                }
            },
            {
                data        : 'users_count',
                title       : 'Users',
                orderable   : true,
                className   : 'text-center',
                customsearch: true
            },
            {
                data        : 'owner_name',
                title       : 'Creator',
                orderable   : false,
                className   : 'text-center',
                customsearch: false
            },
            {
                data        : 'currency_id',
                title       : '',
                orderable   : false,
                className   : 'text-center',
                customsearch: false,
                width       : '25px',
                render      : function(data, type, row) {
                    var isActive = true;
                    var state    = 'ACTIVE';
                    var msg      = 'Active';

                    if (row.price_list_id == null) {
                        isActive = false;
                        msg      = 'Does not have a Price List';
                        state    = 'INACTIVE';
                    } else if (row.quote_template_path == null) {
                        isActive = false;
                        msg      = 'Does not have a Quote Template';
                        state    = 'INACTIVE';
                    }

                    return '<div class="text-center" ' +
                           'data-container="body" data-trigger="hover" data-toggle="popover" ' +
                           'data-placement="top" data-html="true" ' +
                           'data-content="' + msg + '">' +
                           '<i class="fa fa-circle ' + (isActive ? 'fc-success' : 'fc-danger') + '" aria-hidden="true"></i> <br>' +
                           '<small class="text-muted fc-quicksand-bold">' + state + '</small>' +
                           '</div>';
                }
            },
            {
                data        : '',
                orderable   : false,
                className   : 'text-right',
                customsearch: false,
                render      : function(data, type, row) {
                    var $html = '';

                    if (window.PERMISSIONS.company_users__view) {
                        $html += ' <a href="/companies/' + row.id + '/users" class="btn btn-info btn-sm" ' +
                                 'data-toggle="tooltip" data-placement="bottom" title="" data-original-title="Users">' +
                                 '<i class="fa fa-users"></i>' +
                                 '</a>';
                    }

                    if (window.PERMISSIONS.company_users__view) {
                        $html += ' <a href="/companies/' + row.id + '/view" class="btn btn-success btn-sm" ' +
                                 'data-toggle="tooltip" data-placement="bottom" title="" data-original-title="View">' +
                                 '<i class="fa fa-eye"></i>' +
                                 '</a>';
                    }

                    if (window.PERMISSIONS.company_users__edit) {
                        $html += ' <a href="/companies/' + row.id + '/edit" class="btn btn-default btn-sm" ' +
                                 'data-toggle="tooltip" data-placement="bottom" title="" data-original-title="Edit">' +
                                 '<i class="fa fa-pencil"></i>' +
                                 '</a>';
                    }

                    if (window.PERMISSIONS.company_users__delete) {
                        $html += ' <a href="/companies/' + row.id + '/delete" class="btn btn-danger btn-sm" ' +
                                 'data-method="post" data-confirm="Are you sure?" data-token="' + window.TOKEN + '" ' +
                                 'data-toggle="tooltip" data-placement="bottom" title="Delete">' +
                                 '<i class="fa fa-times"></i>' +
                                 '</a>';
                    }

                    return $html;
                }
            }
        ];

        /**
         ***************************************************************************
         * Init
         ***************************************************************************
         */
        this.init = function() {
            if (!$(__body_id).length) {
                return false;
            }

            COLUMNS.forEach(function(element, index) {
                if (element.customsearch) {
                    SEARCH_ROW[ element.data ] = '';
                }
            });

            __assignEvents();
        };

        /**
         ***************************************************************************
         * Events
         ***************************************************************************
         */
        var __assignEvents = function() {
            $.fn.dataTableExt.sErrMode = "console";

            __initTable();
        };

        var __initTable = function() {
            $(__table)
                .on('processing.dt', function(e, settings, processing) {
                    if (processing) {
                    } else {
                        initBaseFunctions();
                    }
                })
                .on('length.dt', function(e, settings, len) {
                    set_page_length('companies_index', len);
                })
                .DataTable({
                    "dom"         : '<"row"' +
                                    '<"col-md-8"i>' +
                                    '<"col-md-4 text-right"l>' +
                                    '>' +
                                    '<"row dt-table"' +
                                    '<"col-md-12"tr>' +
                                    '>' +
                                    '<"row"' +
                                    '<"col-md-8"i>' +
                                    '<"col-md-4 text-right"p>' +
                                    '>',
                    "lengthChange": true,
                    "lengthMenu"  : [ [ 10, 25, 50, 100, 250, 500 ], [ 10, 25, 50, 100, 250, 500 ] ],
                    "pageLength"  : get_page_length('companies_index'),
                    "filter"      : false,
                    "searching"   : false,
                    "pagingType"  : 'full_numbers',
                    "processing"  : true,
                    "serverSide"  : true,
                    "order"       : [ [ 1, 'asc' ] ],
                    "columns"     : COLUMNS,
                    initComplete  : function() {
                        $(this).DataTable().rows().every(function(rowIdx, tableLoop, rowLoop) {
                            var data = this.data();

                            if (data.price_list_id === null) {
                                $(this.node()).addClass('active');
                            }
                        });

                        if (!$(this).find('thead').find('.row-filter').length) {
                            var $rowFilter = '<tr class="row-filter">';

                            COLUMNS.forEach(function(element, index) {
                                $rowFilter += '<td>';

                                if (element.customsearch) {
                                    $rowFilter += '<input type="text" class="form-control fc-input-sm fc-block js-search-field" data-field="' + element.data + '">';
                                }

                                $rowFilter += '</td>';
                            });

                            $rowFilter += '</tr>';

                            $(this).find('thead').append($rowFilter);
                        }
                    },
                    ajax          : function(data, callback, settings) {
                        data.search_row = SEARCH_ROW;

                        $.ajax({
                            url    : window.location.href,
                            data   : data,
                            success: function(response) {
                                callback(response);
                            }
                        });
                    }
                });

            $(__body_id).on('keyup', __table + ' thead .row-filter .js-search-field', function(e) {
                __collectSearches();
            });
        };

        var __collectSearches = function() {
            $(__table + ' thead .row-filter .js-search-field').each(function() {
                var $input = $(this);

                SEARCH_ROW[ $input.data('field') ] = $input.val().trim();
            });

            setTimeout(function() {
                $(__table).DataTable().draw()
            }, 100);
        };

    }).init();

})(jQuery);